import { signatureStyle as signature } from 'now-frontend-shared/styles/signature-styles';
import styles from '../../styles/document-view-styles';

export default {
  inputContainer: styles.inputContainer,
  dateContainer: styles.dateContainer,
  signature,
};
